import { render, staticRenderFns } from "./MdmPagination.vue?vue&type=template&id=23c81398&name=mdm-pagination&"
import script from "./MdmPagination.vue?vue&type=script&lang=js&"
export * from "./MdmPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports